import { firestoreDb, firebaseApp } from './firebase';
import { getAuth, signInWithCustomToken, Auth, UserCredential } from 'firebase/auth';
import { getAnalytics, logEvent } from 'firebase/analytics';

class FirebaseAuth {
    constructor(firebaseUserToken) {
        this.firebaseUserToken = firebaseUserToken;
        this.analytics = getAnalytics(firebaseApp);
    }

    async onUserLogin(userId) {
        logEvent(this.analytics, 'login', {
            method: 'cellphone',   // valgfritt: ekstra parametre
            userId: userId
        });
    }

    async onPageView(pageName) {
        logEvent(this.analytics, 'page_view', {
            page_name: pageName
        });
    }

    async onEvent(eventName, params) {
        logEvent(this.analytics, eventName, params);
    }

    async onUserSignUp(userId) {
        logEvent(this.analytics, 'sign_up', {
            method: 'cellphone',   // valgfritt: ekstra parametre
            userId: userId
        });
    }

    async onUserSignOut(userId) {
        logEvent(this.analytics, 'sign_out', {
            method: 'cellphone',   // valgfritt: ekstra parametre
            userId: userId
        });
    }

    async authenticate() {
        const auth = getAuth();
        try {
            const userCredential = await signInWithCustomToken(auth, this.firebaseUserToken);
            console.log('User signed in:', userCredential.user);
            await this.onUserLogin(userCredential.user.uid);
            return userCredential;
        } catch (error) {
            console.error('Error signing in:', error);
            throw error;
        }
    }
    async signOut() {
        const auth = getAuth();
        try {
            await auth.signOut();
            console.log('User signed out');
        } catch (error) {
            console.error('Error signing out:', error);
            throw error;
        }
    }
    async getCurrentUser() {
        const auth = getAuth();
        const user = auth.currentUser;
        if (user) {
            console.log('Current user:', user);
            return user;
        } else {
            console.log('No user is signed in');
            return null;
        }
    }
    async isAuthenticated() {
        const auth = getAuth();
        const user = auth.currentUser;
        if (user) {
            console.log('User is authenticated:', user);
            return true;
        } else {
            console.log('User is not authenticated');
            return false;
        }
    }
}

export default FirebaseAuth;